<template>
  <div class="about-wrp content-box fadeInUp">
      <h1 class="about-h1">What does B”H stand for?</h1>
      <p class="about-txt-main">B”H stands for Be’ezras Hashem - the Hebrew translation of “with the help (and the will) of God.”</p>
      <p class="about-txt-main">It is a Jewish custom to write this abbreviation at the beginning of a letter, to remember that we’re just doing our portion, but the end result lies in Hashem’s will.</p>
      <p class="about-txt-main">While we work on creating majestic projects, and when we see the beautiful results, we can sometimes get the feeling that the success of the project is all our credit. But upon taking a closer look, we realize that it is all from the true Creator - Hashem. He’s the one that gave us brains to think, eyes to see, ears to hear, and creativity to create a better world.</p>
      <p style="padding-bottom: 4%;" class="about-txt-main">Therefore, we thank Hashem for all the success and the failures (after all, failures help us grow and learn) and we pray that He should continue to put success in all our doings.</p>
  
      <h2 style="padding-bottom: 4%;" class="about-h2">So what does B”H refer to?</h2>
      <h2 class="about-h2">Everything!</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.about-txt-main{
    padding-bottom: 0;
}
</style>